import {
  ServiceLevelVolumeOverTimeRequestSchema,
  ServiceLevelVolumeOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getServiceLevelVolumeOverTime = {
  name: "getServiceLevelVolumeOverTime" as const,
  input: ServiceLevelVolumeOverTimeRequestSchema,
  output: ServiceLevelVolumeOverTimeResponseSchema,
};
